<template>
    <div class="mag-article" v-if="article">
        <breadcrumb :section="{ title: 'Magazine', to: '/espace-client/mag' }" />
        <mag-cover
            :cover="dico.covers[article.category.name] || dico.covers['others']"
            :title="article.category.title"
            :subtitle="article.category.description"
        />
        <main-container>
            <v-row class="article-body">
                <article-table-of-contents :article="article" class="article-table-of-contents" />
                <v-col>
                    <v-card>
                        <mag-article-tools class="article-tools" />
                        <v-card-text>
                            <typo name="title-30-normal">{{ article.title }}</typo>
                            <sep name="L" />
                            <typo name="body-16-light">Mise à jour le {{ updatedAt }}</typo>
                            <sep name="L" />
                            <convention-body :body="article.body"></convention-body>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <sep name="XL" />
            <mag-teaser-articles
                :no-title="true"
                :category="article.category"
                :articles="article.relatedArticles"
            />
        </main-container>
        <scroll-top />
    </div>
</template>

<script>
import MagCover from "./MagCover.vue";
import MagTeaserArticles from "./teaser/MagTeaserArticles.vue";
import MagArticleTools from "./MagArticleTools.vue";
import { Services } from "src/services/Services";
import ConventionBody from "../convention/ConventionBody.vue";
import ArticleTableOfContents from "./table-of-contents/ArticleTableOfContents.vue";
import ScrollTop from "src/components/common/scrollTop/ScrollTop.vue";

export default {
    components: {
        ConventionBody,
        MagTeaserArticles,
        MagCover,
        ArticleTableOfContents,
        ScrollTop,
        MagArticleTools,
    },
    computed: {
        dico() {
            return this.$privateDico.mag;
        },
        updatedAt() {
            if (this.article) {
                return Services.moment(this.article.publishedAt).format("LLL");
            }
            return null;
        },
    },
    asyncComputed: {
        async article() {
            return await Services.api.mag.getArticleBySlugOrContentId(
                this.$route.params.slugOrContentId
            );
        },
    },
};
</script>

<style lang="sass" scoped>
.mag-article
    background-color: $color-background
    padding: 0 0 $grid-gutter 0

.article-tools
    position: absolute
    top: -32px
    right: 0
.article-body
    margin: auto
    margin-top: -50px
    position: relative
    z-index: 2

.typo
    color: $color-secondary

@media print
    .mag-article
        background-color: transparent

    .article-table-of-contents
        display: none

    .article-body
        margin-top: 0

        .col
            padding: 0

        .v-card
            border-radius: 0
            border-top: 1px solid $color-secondary
            box-shadow: none

        .v-card__text
            padding: 5mm 0

        .body-16-light
            margin-bottom: 5mm

        ::v-deep .cc-body
            margin-left: 0
</style>
